import React from "react";
import "./LandingPage.css";
import { Link } from "react-router-dom";
import useTrackClick from "../../services/LandingPage/useHeatMap";
import usePlans from "../../services/LandingPage/usePlans";

const Plans = () => {
  const { trackClick } = useTrackClick();
  const { plans, loading, error } = usePlans("IN");

  const handleClick = async (planId) => {
    const res = await trackClick({
      page: "Pricing",
      button: "Buy Plan",
      planId: planId,
    });
  };

  if (loading) return <p>Loading plans...</p>;
  if (error) return <p>Error loading plans</p>;

  return (
    <div className="pricing-wrap">
      <h2 className="pricing-title">Choose the Perfect Plan for Your Growth</h2>

      <div className="pricing-cards">
        {plans.slice(0, 3).map((plan, index) => (
          <div
            key={plan.id}
            className={`price-card ${index === 1 ? "highlight" : ""}`}
          >
            <h4 className="plan-name">
              {plan.plan_name}
              {index === 1 && <span className="badge">(Most Popular)</span>}
            </h4>

            <div className="price-row">
              <span className="price">
                ₹{Number(plan.plan_price).toFixed(0)} /mo
              </span>
            </div>

            <p className="note">No credit card required!</p>

            <p className="plan-desc">{plan.plan_desc}</p>

            <Link
              to={`/buy-plan/${plan.id}`}
              className="buy-btn"
              onClick={() => handleClick(plan.id)}
            >
              Buy Now →
            </Link>
          </div>
        ))}
      </div>

      <div className="summary-btn-wrap">
        <Link to="/pricing-page" className="summary-btn text-decoration-none">
          View Plan Summary <span>→</span>
        </Link>
      </div>
    </div>
  );
};

export default Plans;
